import styled from 'styled-components'
import { pxToRem } from 'styles/functions'
import { SCTopBarContainer } from 'components/AugmentedReality/Structure/TopBar/styled'

export const SCPhotoEditorContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
`

export const SCTopStack = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 11;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) and (orientation: landscape) {
    width: calc(100% - ${pxToRem(91)});
  }

  /* TopBar is absolute when used standalone; flatten it into the stack here */
  ${SCTopBarContainer} {
    position: static;
    width: 100%;
  }
`

export const SCVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
  touch-action: pinch-zoom;
`;

interface overlayProps {
  $size: number
}

export const SCOverlayImage = styled.img<overlayProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  //max-width: 80%;
  //max-height: 50%;
  max-width: ${({ $size }) => `${$size}px`};
  max-height: ${({ $size }) => `${$size}px`};
  z-index: 2;
  pointer-events: none;

  @media (min-width: 768px) and (orientation: portrait) {
    max-width: 90%;
    max-height: 95%;
  }

  @media (min-width: 768px) and (orientation: landscape) {
    max-width: 90%;
    max-height: 110%;
  }

  -webkit-mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent),
    linear-gradient(to bottom, black, black 95%, transparent);
  mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent),
    linear-gradient(to bottom, black, black 95%, transparent);
  -webkit-mask-composite: destination-in;
  mask-composite: intersect;
`

export const SCStickerContainer = styled.div`
  width: 100%;
  background-color: rgba(35, 35, 35, 0.75);
  padding: ${pxToRem(10)} 0;
`

export const SCStickerScroll = styled.div`
  display: flex;
  gap: ${pxToRem(15)};
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 ${pxToRem(10)};
  scroll-behavior: smooth;
  
  & > :first-child {
    margin-left: auto;
  }
  & > :last-child {
    margin-right: auto;
  }

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: ${pxToRem(2)};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
  }
`

export const SCSticker = styled.img`
  width: ${pxToRem(60)};
  height: ${pxToRem(60)};
  object-fit: contain;
  cursor: pointer;
  flex-shrink: 0;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.1);
  }
`

export const SCPlacedStickerContainer = styled.div`
  width: 100%;
  height: 100%;
  z-index: 1000;
  will-change: transform;
  position: relative;
  pointer-events: auto;
`;

export const SCStickerImg = styled.img`
  width: 100%;
  height: 100%;
  pointer-events: none;
  user-select: none;
  -webkit-user-drag: none;
`;

export const SCStickerDelete = styled.div`
  position: absolute;
  bottom: -45px;
  left: 50%;
  transform: translateX(-50%);
  width: ${pxToRem(30)};
  height: ${pxToRem(30)};
  background: #fff;
  border: ${pxToRem(2)} solid #ff4444;
  border-radius: 100%;
  pointer-events: all;

  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;

  svg {
    color: #ff4444;
    width: ${pxToRem(18)};
    height: ${pxToRem(18)};
  }

  &:hover {
    background: #ff4444;

    svg {
      color: white;
    }
  }
`

export const SCPhotoContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
`

export const SCFrameSliceImg = styled.img`
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 3;
  top: 0;
`
